import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const Dialog = props => {
    return (
        <Modal
            style={props.style}
            className={props.className ? `${props.className} mini-modal` : 'mini-modal'}
            size={props.size ? props.size : 'small'}
            open={props.open}
        >
            <Modal.Header data-testid="ui-header-title">{props.title}</Modal.Header>
            <Modal.Content>
                {props.children}
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={props.onCancel} data-testid="ui-button-cancel">
                    Cancel
                </Button>
                <Button primary loading={props.loading} onClick={props.onConfirm} data-testid="ui-button-confirm">
                    {props.confirmText}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
export default Dialog;